import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import './Staff.css';

import axios from "axios";
import { FaEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import Profile from "../Profile/Profile";
import { toast, ToastContainer } from "react-toastify";

import Breadcrumb from "../Breadcrumb";
import MetaHelmet from "../MetaHelmet";

const AffiliateIndex = () => {
  const [staffs, setStaff] = useState([]);
  const [filteredStaffs, setFilteredStaffs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
 
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const routes = [
    { name: "Home", path: "/dashboard" },
    { name: "Affiliate", path: "/affilate" },
  ];

  useEffect(() => {
    const fetchStaff = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }
      try {
        const response = await axios.get(`${API_BASE_URL}/affilates-list`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { search: searchTerm },
        });
        if (Array.isArray(response.data.affilates)) {
          setStaff(response.data.affilates);
          setFilteredStaffs(response.data.affilates);
        } else {
          setStaff([]);
          console.error("Response data.affilates is not an array");
        }
      } catch (err) {
        setError("Failed to fetch staff data. Please try again.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, [searchTerm, API_BASE_URL, navigate]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleEdit = (id) => {
    navigate(`/staff/update/${id}`);
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    try {
      await axios.delete(`${API_BASE_URL}/delete-affilate/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setStaff(staffs.filter((staff) => staff.id !== id));
      setFilteredStaffs(filteredStaffs.filter((staff) => staff.id !== id));
      toast.success("Affilate deleted Successfully");
    } catch (error) {
      setError("Error deleting staff. Please try again.");
      console.error("Error deleting affiliate:", error);
    }
  };

  
  if (loading) {
    return <p className="loading-message">Loading staff data...</p>;
  }

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  return (
    <>
      <MetaHelmet title={`Local Shouts | Affiliate`}/>
    <div className="container">
    
     
        <Breadcrumb routes={routes} />

        <div className="d-flex bg-white p-3 rounded-2 white-box-shadow">
          <div class="form-group search-bar">
            <input
                type="text"
                placeholder="Search by affiliate name"
                value={searchTerm}
                onChange={handleSearch}
                class="form-control bg-light-gray"
          />
         
        </div>
         <div className="input-reset-div py-1 px-2 ms-3" onClick={() => setSearchTerm('')}>
            <svg fill="#000000" width="20px" height="20px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" class="input-reset">
              <path d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0" fill-rule="evenodd" />
            </svg>
          </div>
          <div className="action-bar ms-auto">
            <Link to="/affilate/create" className="btn ls-btn create-btn">
              <FaPlus /> Create
            </Link>
        </div>
        <ToastContainer />
        </div>

        <div class="mt-5">
        {filteredStaffs.length === 0 ? (
          <p>No record found</p>
        ) : (
        <table class="table table-hover rounded-table white-box-shadow">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile Number</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
          {filteredStaffs.map((staff) => (
                <tr key={staff.id}>
                  <td>{staff.affilate_name}</td>
                  <td>{staff.email}</td>
                  <td>{staff.mobile_number}</td>
                  <td>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleEdit(staff.id)}
                    >
                      <FaEdit />
                    </button>
                    
                    <button
                      className="btn btn-danger ms-2"
                      onClick={() => handleDelete(staff.id)}
                    >
                      <FaTrashAlt />
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
    )}
    </div>

        <Profile setStaff={setStaff} />
      </div>
      </>
    
  );
};

export default AffiliateIndex;
